import { IoIosArrowDown } from "react-icons/io";
import React from "react";

const LabeledSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  defaultOption = null,
  disabled = false,
  labelClassName = null,
}) => (
  <div className="relative w-full">
    <label
      className={
        labelClassName
          ? labelClassName
          : "relative text-[10px] text-gray-700 block"
      }
    >
      {label}
    </label>
    <select
      name={name}
      value={value}
      disabled={disabled}
      onChange={onChange}
      className="custom-select w-full disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-auto"
    >
      {defaultOption && (
        <option value={defaultOption.value}>{defaultOption.label}</option>
      )}
      {options.map(({ label, value }, index) => (
        <option key={index} value={value}>
          {label}
        </option>
      ))}
    </select>
    <IoIosArrowDown className="text-black absolute right-2.5 bottom-2.5 pointer-events-none" />
  </div>
);

export default LabeledSelect;
